import { Link } from 'react-router-dom';
import '../../styles/system.css';

export default function MaintenanceMode() {
  const whatsappText = encodeURIComponent('Hello MF_NAILEDIT, I tried to make a booking but the website says booking is temporarily paused. Please let me know when appointments are available again.');

  return (
    <main className="system-page">
      <section className="system-card system-card-warning" aria-labelledby="maintenance-title">
        <span className="system-pill system-pill-warning">LIMITED ACCESS</span>
        <h1 id="maintenance-title">Booking is temporarily paused</h1>
        <p className="system-copy">
          Public booking and deposit collection may be paused while the studio updates availability, policies or payment settings.
        </p>
        <div className="system-note">
          <span>DEVELOPER RULE</span>
          <p>
            Show this state instead of a broken screen. Preserve clear recovery actions and never expose private booking, payment or customer data while access is limited.
          </p>
        </div>
        <Link className="button button-primary system-action" to="/">Return home</Link>
        <a
          className="button button-secondary system-action"
          href={`https://wa.me/2347069460987?text=${whatsappText}`}
          target="_blank"
          rel="noreferrer"
        >
          Open WhatsApp
        </a>
      </section>
    </main>
  );
}
